// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("images/icons/chevron-down.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("images/icons/text-paragraph.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("images/icons/type-h1.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("images/icons/type-h2.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("images/icons/chat-square-quote.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("images/icons/list-ul.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("images/icons/list-ol.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("images/icons/code.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("images/icons/pencil-fill.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("images/icons/arrow-counterclockwise.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("images/icons/arrow-clockwise.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("images/icons/type-bold.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("images/icons/type-italic.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("images/icons/type-underline.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("images/icons/type-strikethrough.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("images/icons/link.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("images/icons/text-left.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("images/icons/text-center.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("images/icons/text-right.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("images/icons/justify.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rtf-body {
    margin: 0;
    background: #eee;
    font-family: system-ui, -apple-system, BlinkMacSystemFont, ".SFNSText-Regular",
      sans-serif;
    font-weight: 500;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  
  .other h2 {
    font-size: 18px;
    color: #444;
    margin-bottom: 7px;
  }
  
  .other a {
    color: #777;
    text-decoration: underline;
    font-size: 14px;
  }
  
  .other ul {
    padding: 0;
    margin: 0;
    list-style-type: none;
  }
  
  .App {
    font-family: sans-serif;
    text-align: center;
  }
  
  h1 {
    font-size: 24px;
    color: #333;
  }
  
  .ltr {
    text-align: left;
  }
  
  .rtl {
    text-align: right;
  }

.editor-container {
    /* margin: 20px auto 20px auto; */
    /* border-radius: 2px; */
    /* max-width: 600px; */
    /* color: #000; */
    /* position: relative; */
    /* line-height: 20px; */
    /* font-weight: 400; */
    /* text-align: left; */
    /* border-top-left-radius: 10px; */
    /* border-top-right-radius: 10px; */
  }
  
  .editor-inner {
    background: #fff;
    position: relative;
  }
  
  .editor-input {
    min-height: 100px;
    resize: none;
    font-size: 15px;
    position: relative;
    tab-size: 1;
    outline: 0;
    padding: 15px 10px;
    caret-color: #444;
  }

  .editor-input-readonly {
    min-height: 100px;
    resize: none;
    font-size: 15px;
    position: relative;
    tab-size: 1;
    outline: 0;
    caret-color: #444;
  }

  .editor-input-disabled {
    min-height: 100px;
    resize: none;
    font-size: 15px;
    position: relative;
    tab-size: 1;
    outline: 0;
    padding: 15px 10px;
    caret-color: #444;
    cursor: not-allowed;
    --tw-bg-opacity: 1;
    background-color: rgb(248 249 250 / var(--tw-bg-opacity, 1))}
  
  .editor-placeholder {
    color: #999;
    overflow: hidden;
    position: absolute;
    text-overflow: ellipsis;
    top: 15px;
    left: 10px;
    font-size: 15px;
    -webkit-user-select: none;
            user-select: none;
    display: inline-block;
    pointer-events: none;
  }
  
  .editor-text-bold {
    font-weight: bold;
  }
  
  .editor-text-italic {
    font-style: italic;
  }
  
  .editor-text-underline {
    text-decoration: underline;
  }
  
  .editor-text-strikethrough {
    text-decoration: line-through;
  }
  
  .editor-text-underlineStrikethrough {
    text-decoration: underline line-through;
  }
  
  .editor-text-code {
    background-color: rgb(240, 242, 245);
    padding: 1px 0.25rem;
    font-family: Menlo, Consolas, Monaco, monospace;
    font-size: 94%;
  }
  
  .editor-link {
    color: rgb(33, 111, 219);
    text-decoration: none;
  }
  
  .tree-view-output {
    display: block;
    background: #222;
    color: #fff;
    padding: 5px;
    font-size: 12px;
    white-space: pre-wrap;
    margin: 1px auto 10px auto;
    max-height: 250px;
    position: relative;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    overflow: auto;
    line-height: 14px;
  }
  
  .editor-code {
    background-color: rgb(240, 242, 245);
    font-family: Menlo, Consolas, Monaco, monospace;
    display: block;
    padding: 8px 8px 8px 52px;
    line-height: 1.53;
    font-size: 13px;
    margin: 0;
    margin-top: 8px;
    margin-bottom: 8px;
    tab-size: 2;
    /* white-space: pre; */
    overflow-x: auto;
    position: relative;
  }
  
  .editor-code:before {
    content: attr(data-gutter);
    position: absolute;
    background-color: #eee;
    left: 0;
    top: 0;
    border-right: 1px solid #ccc;
    padding: 8px;
    color: #777;
    white-space: pre-wrap;
    text-align: right;
    min-width: 25px;
  }
  .editor-code:after {
    content: attr(data-highlight-language);
    top: 0;
    right: 3px;
    padding: 3px;
    font-size: 10px;
    text-transform: uppercase;
    position: absolute;
    color: rgba(0, 0, 0, 0.5);
  }
  
  .editor-tokenComment {
    color: slategray;
  }
  
  .editor-tokenPunctuation {
    color: #999;
  }
  
  .editor-tokenProperty {
    color: #905;
  }
  
  .editor-tokenSelector {
    color: #690;
  }
  
  .editor-tokenOperator {
    color: #9a6e3a;
  }
  
  .editor-tokenAttr {
    color: #07a;
  }
  
  .editor-tokenVariable {
    color: #e90;
  }
  
  .editor-tokenFunction {
    color: #dd4a68;
  }
  
  .editor-paragraph {
    margin: 0;
    margin-bottom: 8px;
    position: relative;
  }
  
  .editor-paragraph:last-child {
    margin-bottom: 0;
  }
  
  .editor-heading-h1 {
    font-size: 24px;
    color: rgb(5, 5, 5);
    font-weight: 400;
    margin: 0;
    margin-bottom: 12px;
    padding: 0;
  }
  
  .editor-heading-h2 {
    font-size: 15px;
    color: rgb(101, 103, 107);
    font-weight: 700;
    margin: 0;
    margin-top: 10px;
    padding: 0;
    text-transform: uppercase;
  }
  
  .editor-quote {
    margin: 0;
    margin-left: 20px;
    font-size: 15px;
    color: rgb(101, 103, 107);
    border-left-color: rgb(206, 208, 212);
    border-left-width: 4px;
    border-left-style: solid;
    padding-left: 16px;
  }
  
  .editor-list-ol {
    padding: 0;
    margin: 0;
    margin-left: 16px;
  }
  
  .editor-list-ul {
    padding: 0;
    margin: 0;
    margin-left: 16px;
  }
  
  .editor-listitem {
    margin: 8px 32px 8px 32px;
  }
  
  .editor-nested-listitem {
    list-style-type: none;
  }
  
  pre::-webkit-scrollbar {
    background: transparent;
    width: 10px;
  }
  
  pre::-webkit-scrollbar-thumb {
    background: #999;
  }
  
  .debug-timetravel-panel {
    overflow: hidden;
    padding: 0 0 10px 0;
    margin: auto;
    display: flex;
  }
  
  .debug-timetravel-panel-slider {
    padding: 0;
    flex: 8 1;
  }
  
  .debug-timetravel-panel-button {
    padding: 0;
    border: 0;
    background: none;
    flex: 1 1;
    color: #fff;
    font-size: 12px;
  }
  
  .debug-timetravel-panel-button:hover {
    text-decoration: underline;
  }
  
  .debug-timetravel-button {
    border: 0;
    padding: 0;
    font-size: 12px;
    top: 10px;
    right: 15px;
    position: absolute;
    background: none;
    color: #fff;
  }
  
  .debug-timetravel-button:hover {
    text-decoration: underline;
  }
  
  .emoji {
    color: transparent;
    background-size: 16px 16px;
    background-position: center;
    background-repeat: no-repeat;
    vertical-align: middle;
    margin: 0 -1px;
  }
  
  .emoji-inner {
    padding: 0 0.15em;
  }
  
  .emoji-inner::selection {
    color: transparent;
    background-color: rgba(150, 150, 150, 0.4);
  }
  
  .emoji-inner::moz-selection {
    color: transparent;
    background-color: rgba(150, 150, 150, 0.4);
  }
  
  /* .emoji.happysmile {
    background-image: url(./images/emoji/1F642.png);
  } */
  
  .toolbar {
    display: flex;
    margin-bottom: 1px;
    background: #fff;
    padding: 4px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    vertical-align: middle;
  }

  .toolbar-disabled {
    display: flex;
    margin-bottom: 1px;
    background: #fff;
    padding: 4px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    vertical-align: middle;
    cursor: not-allowed;
    --tw-bg-opacity: 1;
    background-color: rgb(248 249 250 / var(--tw-bg-opacity, 1))}
  
  .toolbar button.toolbar-item {
    border: 0;
    display: flex;
    background: none;
    border-radius: 10px;
    padding: 8px;
    cursor: pointer;
    vertical-align: middle;
  }
  
  .toolbar button.toolbar-item:disabled {
    cursor: not-allowed;
  }
  
  .toolbar button.toolbar-item.spaced {
    margin-right: 2px;
  }
  
  .toolbar button.toolbar-item i.format {
    background-size: contain;
    height: 18px;
    width: 18px;
    margin-top: 2px;
    vertical-align: -0.25em;
    display: flex;
    opacity: 0.6;
  }
  
  .toolbar button.toolbar-item:disabled i.format {
    opacity: 0.2;
  }
  
  .toolbar button.toolbar-item.active {
    background-color: rgba(223, 232, 250, 0.3);
  }
  
  .toolbar button.toolbar-item.active i {
    opacity: 1;
  }
  
  .toolbar .toolbar-item:hover:not([disabled]) {
    background-color: #eee;
  }
  
  .toolbar .divider {
    width: 1px;
    background-color: #eee;
    margin: 0 4px;
  }
  
  .toolbar select.toolbar-item {
    border: 0;
    display: flex;
    background: none;
    border-radius: 10px;
    padding: 8px;
    vertical-align: middle;
    -webkit-appearance: none;
    -moz-appearance: none;
    width: 70px;
    font-size: 14px;
    color: #777;
    text-overflow: ellipsis;
  }
  
  .toolbar select.code-language {
    text-transform: capitalize;
    width: 130px;
  }
  
  .toolbar .toolbar-item .text {
    display: flex;
    line-height: 20px;
    vertical-align: middle;
    font-size: 14px;
    color: #777;
    text-overflow: ellipsis;
    width: 70px;
    overflow: hidden;
    height: 20px;
    text-align: left;
  }
  
  .toolbar .toolbar-item .icon {
    display: flex;
    width: 20px;
    height: 20px;
    -webkit-user-select: none;
            user-select: none;
    margin-right: 8px;
    line-height: 16px;
    background-size: contain;
  }
  
  .toolbar i.chevron-down {
    margin-top: 3px;
    width: 16px;
    height: 16px;
    display: flex;
    -webkit-user-select: none;
            user-select: none;
  }
  
  .toolbar i.chevron-down.inside {
    width: 16px;
    height: 16px;
    display: flex;
    margin-left: -25px;
    margin-top: 11px;
    margin-right: 10px;
    pointer-events: none;
  }

  .toolbar-disabled button.toolbar-item {
    border: 0;
    display: flex;
    background: none;
    border-radius: 10px;
    padding: 8px;
    cursor: pointer;
    vertical-align: middle;
  }
  
  .toolbar-disabled button.toolbar-item:disabled {
    cursor: not-allowed;
  }
  
  .toolbar-disabled button.toolbar-item.spaced {
    margin-right: 2px;
  }
  
  .toolbar-disabled button.toolbar-item i.format {
    background-size: contain;
    height: 18px;
    width: 18px;
    margin-top: 2px;
    vertical-align: -0.25em;
    display: flex;
    opacity: 0.6;
  }
  
  .toolbar-disabled button.toolbar-item:disabled i.format {
    opacity: 0.2;
  }
  
  .toolbar-disabled button.toolbar-item.active {
    background-color: rgba(223, 232, 250, 0.3);
  }
  
  .toolbar-disabled button.toolbar-item.active i {
    opacity: 1;
  }
  
  .toolbar-disabled .toolbar-item:hover:not([disabled]) {
    background-color: #eee;
  }
  
  .toolbar-disabled .divider {
    width: 1px;
    background-color: #eee;
    margin: 0 4px;
  }
  
  .toolbar-disabled select.toolbar-item {
    border: 0;
    display: flex;
    background: none;
    border-radius: 10px;
    padding: 8px;
    vertical-align: middle;
    -webkit-appearance: none;
    -moz-appearance: none;
    width: 70px;
    font-size: 14px;
    color: #777;
    text-overflow: ellipsis;
  }
  
  .toolbar-disabled select.code-language {
    text-transform: capitalize;
    width: 130px;
  }
  
  .toolbar-disabled .toolbar-item .text {
    display: flex;
    line-height: 20px;
    vertical-align: middle;
    font-size: 14px;
    color: #777;
    text-overflow: ellipsis;
    width: 70px;
    overflow: hidden;
    height: 20px;
    text-align: left;
  }
  
  .toolbar-disabled .toolbar-item .icon {
    display: flex;
    width: 20px;
    height: 20px;
    -webkit-user-select: none;
            user-select: none;
    margin-right: 8px;
    line-height: 16px;
    background-size: contain;
  }
  
  .toolbar-disabled i.chevron-down {
    margin-top: 3px;
    width: 16px;
    height: 16px;
    display: flex;
    -webkit-user-select: none;
            user-select: none;
  }
  
  .toolbar-disabled i.chevron-down.inside {
    width: 16px;
    height: 16px;
    display: flex;
    margin-left: -25px;
    margin-top: 11px;
    margin-right: 10px;
    pointer-events: none;
  }
  
  i.chevron-down {
    background-color: transparent;
    background-size: contain;
    display: inline-block;
    height: 8px;
    width: 8px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  }
  
  #block-controls button:hover {
    background-color: #efefef;
  }
  
  #block-controls button:focus-visible {
    border-color: blue;
  }
  
  #block-controls span.block-type {
    background-size: contain;
    display: block;
    width: 18px;
    height: 18px;
    margin: 2px;
  }
  
  #block-controls span.block-type.paragraph {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  }
  
  #block-controls span.block-type.h1 {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  }
  
  #block-controls span.block-type.h2 {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  }
  
  #block-controls span.block-type.quote {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  }
  
  #block-controls span.block-type.ul {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  }
  
  #block-controls span.block-type.ol {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  }
  
  #block-controls span.block-type.code {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  }
  
  .rtf-dropdown {
    z-index: 5;
    display: block;
    position: absolute;
    box-shadow: 0 12px 28px 0 rgba(0, 0, 0, 0.2), 0 2px 4px 0 rgba(0, 0, 0, 0.1),
      inset 0 0 0 1px rgba(255, 255, 255, 0.5);
    border-radius: 8px;
    min-width: 100px;
    min-height: 40px;
    background-color: #fff;
  }
  
  .rtf-dropdown .item {
    margin: 0 8px 0 8px;
    padding: 8px;
    color: #050505;
    cursor: pointer;
    line-height: 16px;
    font-size: 15px;
    display: flex;
    align-content: center;
    flex-direction: row;
    flex-shrink: 0;
    justify-content: space-between;
    background-color: #fff;
    border-radius: 8px;
    border: 0;
    min-width: 268px;
  }
  
  .rtf-dropdown .item .active {
    display: flex;
    width: 20px;
    height: 20px;
    background-size: contain;
  }
  
  .rtf-dropdown .item:first-child {
    margin-top: 8px;
  }
  
  .rtf-dropdown .item:last-child {
    margin-bottom: 8px;
  }
  
  .rtf-dropdown .item:hover {
    background-color: #eee;
  }
  
  .rtf-dropdown .item .text {
    display: flex;
    line-height: 20px;
    flex-grow: 1;
    width: 200px;
  }
  
  .rtf-dropdown .item .icon {
    display: flex;
    width: 20px;
    height: 20px;
    -webkit-user-select: none;
            user-select: none;
    margin-right: 12px;
    line-height: 16px;
    background-size: contain;
  }
  
  .link-editor {
    position: absolute;
    z-index: 100;
    top: -10000px;
    left: -10000px;
    margin-top: -6px;
    max-width: 300px;
    width: 100%;
    opacity: 0;
    background-color: #fff;
    box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.3);
    border-radius: 8px;
    transition: opacity 0.5s;
  }
  
  .link-editor .link-input {
    display: block;
    width: calc(100% - 24px);
    box-sizing: border-box;
    margin: 8px 12px;
    padding: 8px 12px;
    border-radius: 15px;
    background-color: #eee;
    font-size: 15px;
    color: rgb(5, 5, 5);
    border: 0;
    outline: 0;
    position: relative;
    font-family: inherit;
  }
  
  .link-editor div.link-edit {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
    background-size: 16px;
    background-position: center;
    background-repeat: no-repeat;
    width: 35px;
    vertical-align: -0.25em;
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    cursor: pointer;
  }
  
  .link-editor .link-input a {
    color: rgb(33, 111, 219);
    text-decoration: none;
    display: block;
    white-space: nowrap;
    overflow: hidden;
    margin-right: 30px;
    text-overflow: ellipsis;
  }
  
  .link-editor .link-input a:hover {
    text-decoration: underline;
  }
  
  .link-editor .button {
    width: 20px;
    height: 20px;
    display: inline-block;
    padding: 6px;
    border-radius: 8px;
    cursor: pointer;
    margin: 0 2px;
  }
  
  .link-editor .button.hovered {
    width: 20px;
    height: 20px;
    display: inline-block;
    background-color: #eee;
  }
  
  .link-editor .button i,
  .actions i {
    background-size: contain;
    display: inline-block;
    height: 20px;
    width: 20px;
    vertical-align: -0.25em;
  }
  
  i.undo {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  }
  
  i.redo {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  }
  
  .icon.paragraph {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  }
  
  .icon.large-heading,
  .icon.h1 {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  }
  
  .icon.small-heading,
  .icon.h2 {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  }
  
  .icon.bullet-list,
  .icon.ul {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  }
  
  .icon.numbered-list,
  .icon.ol {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  }
  
  .icon.quote {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  }
  
  .icon.code {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  }
  
  i.bold {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  }
  
  i.italic {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  }
  
  i.underline {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  }
  
  i.strikethrough {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  }
  
  i.code {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  }
  
  i.link {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  }
  
  i.left-align {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  }
  
  i.center-align {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
  }
  
  i.right-align {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  }
  
  i.justify-align {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  }`, "",{"version":3,"sources":["webpack://./src/components/Common/RichTextEditor/style.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,gBAAgB;IAChB;gBACY;IACZ,gBAAgB;IAChB,mCAAmC;IACnC,kCAAkC;EACpC;;EAEA;IACE,eAAe;IACf,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,0BAA0B;IAC1B,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,SAAS;IACT,qBAAqB;EACvB;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;AAEF;IACI,iCAAiC;IACjC,wBAAwB;IACxB,sBAAsB;IACtB,iBAAiB;IACjB,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;IACtB,sBAAsB;IACtB,kCAAkC;IAClC,mCAAmC;EACrC;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,kBAAkB;IAClB,iBAAiB;IACjB,mBAAuC;IAAvC,kBAAuC;IAAvC,4DACF;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,uBAAuB;IACvB,SAAS;IACT,UAAU;IACV,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;IACjB,qBAAqB;IACrB,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,uCAAuC;EACzC;;EAEA;IACE,oCAAoC;IACpC,oBAAoB;IACpB,+CAA+C;IAC/C,cAAc;EAChB;;EAEA;IACE,wBAAwB;IACxB,qBAAqB;EACvB;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,qBAAqB;IACrB,0BAA0B;IAC1B,iBAAiB;IACjB,kBAAkB;IAClB,+BAA+B;IAC/B,gCAAgC;IAChC,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,oCAAoC;IACpC,+CAA+C;IAC/C,cAAc;IACd,yBAAyB;IACzB,iBAAiB;IACjB,eAAe;IACf,SAAS;IACT,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;IAC1B,kBAAkB;IAClB,sBAAsB;IACtB,OAAO;IACP,MAAM;IACN,4BAA4B;IAC5B,YAAY;IACZ,WAAW;IACX,qBAAqB;IACrB,iBAAiB;IACjB,eAAe;EACjB;EACA;IACE,sCAAsC;IACtC,MAAM;IACN,UAAU;IACV,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,SAAS;IACT,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,SAAS;IACT,mBAAmB;IACnB,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,yBAAyB;IACzB,gBAAgB;IAChB,SAAS;IACT,gBAAgB;IAChB,UAAU;IACV,yBAAyB;EAC3B;;EAEA;IACE,SAAS;IACT,iBAAiB;IACjB,eAAe;IACf,yBAAyB;IACzB,qCAAqC;IACrC,sBAAsB;IACtB,wBAAwB;IACxB,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,SAAS;IACT,iBAAiB;EACnB;;EAEA;IACE,UAAU;IACV,SAAS;IACT,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,UAAU;IACV,SAAO;EACT;;EAEA;IACE,UAAU;IACV,SAAS;IACT,gBAAgB;IAChB,SAAO;IACP,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,SAAS;IACT,UAAU;IACV,eAAe;IACf,SAAS;IACT,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;IAClB,0BAA0B;IAC1B,2BAA2B;IAC3B,4BAA4B;IAC5B,sBAAsB;IACtB,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,0CAA0C;EAC5C;;EAEA;IACE,kBAAkB;IAClB,0CAA0C;EAC5C;;EAEA;;KAEG;;EAEH;IACE,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,4BAA4B;IAC5B,6BAA6B;IAC7B,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,4BAA4B;IAC5B,6BAA6B;IAC7B,sBAAsB;IACtB,mBAAuC;IAAvC,kBAAuC;IAAvC,4DACF;;EAEA;IACE,SAAS;IACT,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,wBAAwB;IACxB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,uBAAuB;IACvB,aAAa;IACb,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,0CAA0C;EAC5C;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,UAAU;IACV,sBAAsB;IACtB,aAAa;EACf;;EAEA;IACE,SAAS;IACT,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,sBAAsB;IACtB,wBAAwB;IACxB,qBAAqB;IACrB,WAAW;IACX,eAAe;IACf,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;IAC1B,YAAY;EACd;;EAEA;IACE,aAAa;IACb,iBAAiB;IACjB,sBAAsB;IACtB,eAAe;IACf,WAAW;IACX,uBAAuB;IACvB,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,WAAW;IACX,YAAY;IACZ,yBAAiB;YAAjB,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;IACjB,wBAAwB;EAC1B;;EAEA;IACE,eAAe;IACf,WAAW;IACX,YAAY;IACZ,aAAa;IACb,yBAAiB;YAAjB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,SAAS;IACT,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,wBAAwB;IACxB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,uBAAuB;IACvB,aAAa;IACb,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,0CAA0C;EAC5C;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,UAAU;IACV,sBAAsB;IACtB,aAAa;EACf;;EAEA;IACE,SAAS;IACT,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,sBAAsB;IACtB,wBAAwB;IACxB,qBAAqB;IACrB,WAAW;IACX,eAAe;IACf,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;IAC1B,YAAY;EACd;;EAEA;IACE,aAAa;IACb,iBAAiB;IACjB,sBAAsB;IACtB,eAAe;IACf,WAAW;IACX,uBAAuB;IACvB,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,WAAW;IACX,YAAY;IACZ,yBAAiB;YAAjB,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;IACjB,wBAAwB;EAC1B;;EAEA;IACE,eAAe;IACf,WAAW;IACX,YAAY;IACZ,aAAa;IACb,yBAAiB;YAAjB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,6BAA6B;IAC7B,wBAAwB;IACxB,qBAAqB;IACrB,WAAW;IACX,UAAU;IACV,yDAAoD;EACtD;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,wBAAwB;IACxB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,yDAAsD;EACxD;;EAEA;IACE,yDAA+C;EACjD;;EAEA;IACE,yDAA+C;EACjD;;EAEA;IACE,yDAAyD;EAC3D;;EAEA;IACE,yDAA+C;EACjD;;EAEA;IACE,yDAA+C;EACjD;;EAEA;IACE,yDAA4C;EAC9C;;EAEA;IACE,UAAU;IACV,cAAc;IACd,kBAAkB;IAClB;8CAC0C;IAC1C,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;IACnB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,aAAa;IACb,qBAAqB;IACrB,mBAAmB;IACnB,cAAc;IACd,8BAA8B;IAC9B,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,WAAW;IACX,YAAY;IACZ,wBAAwB;EAC1B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,iBAAiB;IACjB,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,aAAa;IACb,WAAW;IACX,YAAY;IACZ,yBAAiB;YAAjB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,wBAAwB;EAC1B;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,UAAU;IACV,sBAAsB;IACtB,2CAA2C;IAC3C,kBAAkB;IAClB,wBAAwB;EAC1B;;EAEA;IACE,cAAc;IACd,wBAAwB;IACxB,sBAAsB;IACtB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;IACf,mBAAmB;IACnB,SAAS;IACT,UAAU;IACV,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,yDAAmD;IACnD,qBAAqB;IACrB,2BAA2B;IAC3B,4BAA4B;IAC5B,WAAW;IACX,uBAAuB;IACvB,kBAAkB;IAClB,QAAQ;IACR,MAAM;IACN,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,wBAAwB;IACxB,qBAAqB;IACrB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,sBAAsB;EACxB;;EAEA;;IAEE,wBAAwB;IACxB,qBAAqB;IACrB,YAAY;IACZ,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,yDAA8D;EAChE;;EAEA;IACE,0DAAuD;EACzD;;EAEA;IACE,yDAAsD;EACxD;;EAEA;;IAEE,yDAA+C;EACjD;;EAEA;;IAEE,yDAA+C;EACjD;;EAEA;;IAEE,yDAA+C;EACjD;;EAEA;;IAEE,yDAA+C;EACjD;;EAEA;IACE,yDAAyD;EAC3D;;EAEA;IACE,yDAA4C;EAC9C;;EAEA;IACE,0DAAiD;EACnD;;EAEA;IACE,0DAAmD;EACrD;;EAEA;IACE,0DAAsD;EACxD;;EAEA;IACE,0DAA0D;EAC5D;;EAEA;IACE,yDAA4C;EAC9C;;EAEA;IACE,0DAA4C;EAC9C;;EAEA;IACE,0DAAiD;EACnD;;EAEA;IACE,0DAAmD;EACrD;;EAEA;IACE,0DAAkD;EACpD;;EAEA;IACE,0DAA+C;EACjD","sourcesContent":[".rtf-body {\n    margin: 0;\n    background: #eee;\n    font-family: system-ui, -apple-system, BlinkMacSystemFont, \".SFNSText-Regular\",\n      sans-serif;\n    font-weight: 500;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n  }\n  \n  .other h2 {\n    font-size: 18px;\n    color: #444;\n    margin-bottom: 7px;\n  }\n  \n  .other a {\n    color: #777;\n    text-decoration: underline;\n    font-size: 14px;\n  }\n  \n  .other ul {\n    padding: 0;\n    margin: 0;\n    list-style-type: none;\n  }\n  \n  .App {\n    font-family: sans-serif;\n    text-align: center;\n  }\n  \n  h1 {\n    font-size: 24px;\n    color: #333;\n  }\n  \n  .ltr {\n    text-align: left;\n  }\n  \n  .rtl {\n    text-align: right;\n  }\n\n.editor-container {\n    /* margin: 20px auto 20px auto; */\n    /* border-radius: 2px; */\n    /* max-width: 600px; */\n    /* color: #000; */\n    /* position: relative; */\n    /* line-height: 20px; */\n    /* font-weight: 400; */\n    /* text-align: left; */\n    /* border-top-left-radius: 10px; */\n    /* border-top-right-radius: 10px; */\n  }\n  \n  .editor-inner {\n    background: #fff;\n    position: relative;\n  }\n  \n  .editor-input {\n    min-height: 100px;\n    resize: none;\n    font-size: 15px;\n    position: relative;\n    tab-size: 1;\n    outline: 0;\n    padding: 15px 10px;\n    caret-color: #444;\n  }\n\n  .editor-input-readonly {\n    min-height: 100px;\n    resize: none;\n    font-size: 15px;\n    position: relative;\n    tab-size: 1;\n    outline: 0;\n    caret-color: #444;\n  }\n\n  .editor-input-disabled {\n    min-height: 100px;\n    resize: none;\n    font-size: 15px;\n    position: relative;\n    tab-size: 1;\n    outline: 0;\n    padding: 15px 10px;\n    caret-color: #444;\n    @apply bg-primary-200 cursor-not-allowed\n  }\n  \n  .editor-placeholder {\n    color: #999;\n    overflow: hidden;\n    position: absolute;\n    text-overflow: ellipsis;\n    top: 15px;\n    left: 10px;\n    font-size: 15px;\n    user-select: none;\n    display: inline-block;\n    pointer-events: none;\n  }\n  \n  .editor-text-bold {\n    font-weight: bold;\n  }\n  \n  .editor-text-italic {\n    font-style: italic;\n  }\n  \n  .editor-text-underline {\n    text-decoration: underline;\n  }\n  \n  .editor-text-strikethrough {\n    text-decoration: line-through;\n  }\n  \n  .editor-text-underlineStrikethrough {\n    text-decoration: underline line-through;\n  }\n  \n  .editor-text-code {\n    background-color: rgb(240, 242, 245);\n    padding: 1px 0.25rem;\n    font-family: Menlo, Consolas, Monaco, monospace;\n    font-size: 94%;\n  }\n  \n  .editor-link {\n    color: rgb(33, 111, 219);\n    text-decoration: none;\n  }\n  \n  .tree-view-output {\n    display: block;\n    background: #222;\n    color: #fff;\n    padding: 5px;\n    font-size: 12px;\n    white-space: pre-wrap;\n    margin: 1px auto 10px auto;\n    max-height: 250px;\n    position: relative;\n    border-bottom-left-radius: 10px;\n    border-bottom-right-radius: 10px;\n    overflow: auto;\n    line-height: 14px;\n  }\n  \n  .editor-code {\n    background-color: rgb(240, 242, 245);\n    font-family: Menlo, Consolas, Monaco, monospace;\n    display: block;\n    padding: 8px 8px 8px 52px;\n    line-height: 1.53;\n    font-size: 13px;\n    margin: 0;\n    margin-top: 8px;\n    margin-bottom: 8px;\n    tab-size: 2;\n    /* white-space: pre; */\n    overflow-x: auto;\n    position: relative;\n  }\n  \n  .editor-code:before {\n    content: attr(data-gutter);\n    position: absolute;\n    background-color: #eee;\n    left: 0;\n    top: 0;\n    border-right: 1px solid #ccc;\n    padding: 8px;\n    color: #777;\n    white-space: pre-wrap;\n    text-align: right;\n    min-width: 25px;\n  }\n  .editor-code:after {\n    content: attr(data-highlight-language);\n    top: 0;\n    right: 3px;\n    padding: 3px;\n    font-size: 10px;\n    text-transform: uppercase;\n    position: absolute;\n    color: rgba(0, 0, 0, 0.5);\n  }\n  \n  .editor-tokenComment {\n    color: slategray;\n  }\n  \n  .editor-tokenPunctuation {\n    color: #999;\n  }\n  \n  .editor-tokenProperty {\n    color: #905;\n  }\n  \n  .editor-tokenSelector {\n    color: #690;\n  }\n  \n  .editor-tokenOperator {\n    color: #9a6e3a;\n  }\n  \n  .editor-tokenAttr {\n    color: #07a;\n  }\n  \n  .editor-tokenVariable {\n    color: #e90;\n  }\n  \n  .editor-tokenFunction {\n    color: #dd4a68;\n  }\n  \n  .editor-paragraph {\n    margin: 0;\n    margin-bottom: 8px;\n    position: relative;\n  }\n  \n  .editor-paragraph:last-child {\n    margin-bottom: 0;\n  }\n  \n  .editor-heading-h1 {\n    font-size: 24px;\n    color: rgb(5, 5, 5);\n    font-weight: 400;\n    margin: 0;\n    margin-bottom: 12px;\n    padding: 0;\n  }\n  \n  .editor-heading-h2 {\n    font-size: 15px;\n    color: rgb(101, 103, 107);\n    font-weight: 700;\n    margin: 0;\n    margin-top: 10px;\n    padding: 0;\n    text-transform: uppercase;\n  }\n  \n  .editor-quote {\n    margin: 0;\n    margin-left: 20px;\n    font-size: 15px;\n    color: rgb(101, 103, 107);\n    border-left-color: rgb(206, 208, 212);\n    border-left-width: 4px;\n    border-left-style: solid;\n    padding-left: 16px;\n  }\n  \n  .editor-list-ol {\n    padding: 0;\n    margin: 0;\n    margin-left: 16px;\n  }\n  \n  .editor-list-ul {\n    padding: 0;\n    margin: 0;\n    margin-left: 16px;\n  }\n  \n  .editor-listitem {\n    margin: 8px 32px 8px 32px;\n  }\n  \n  .editor-nested-listitem {\n    list-style-type: none;\n  }\n  \n  pre::-webkit-scrollbar {\n    background: transparent;\n    width: 10px;\n  }\n  \n  pre::-webkit-scrollbar-thumb {\n    background: #999;\n  }\n  \n  .debug-timetravel-panel {\n    overflow: hidden;\n    padding: 0 0 10px 0;\n    margin: auto;\n    display: flex;\n  }\n  \n  .debug-timetravel-panel-slider {\n    padding: 0;\n    flex: 8;\n  }\n  \n  .debug-timetravel-panel-button {\n    padding: 0;\n    border: 0;\n    background: none;\n    flex: 1;\n    color: #fff;\n    font-size: 12px;\n  }\n  \n  .debug-timetravel-panel-button:hover {\n    text-decoration: underline;\n  }\n  \n  .debug-timetravel-button {\n    border: 0;\n    padding: 0;\n    font-size: 12px;\n    top: 10px;\n    right: 15px;\n    position: absolute;\n    background: none;\n    color: #fff;\n  }\n  \n  .debug-timetravel-button:hover {\n    text-decoration: underline;\n  }\n  \n  .emoji {\n    color: transparent;\n    background-size: 16px 16px;\n    background-position: center;\n    background-repeat: no-repeat;\n    vertical-align: middle;\n    margin: 0 -1px;\n  }\n  \n  .emoji-inner {\n    padding: 0 0.15em;\n  }\n  \n  .emoji-inner::selection {\n    color: transparent;\n    background-color: rgba(150, 150, 150, 0.4);\n  }\n  \n  .emoji-inner::moz-selection {\n    color: transparent;\n    background-color: rgba(150, 150, 150, 0.4);\n  }\n  \n  /* .emoji.happysmile {\n    background-image: url(./images/emoji/1F642.png);\n  } */\n  \n  .toolbar {\n    display: flex;\n    margin-bottom: 1px;\n    background: #fff;\n    padding: 4px;\n    border-top-left-radius: 10px;\n    border-top-right-radius: 10px;\n    vertical-align: middle;\n  }\n\n  .toolbar-disabled {\n    display: flex;\n    margin-bottom: 1px;\n    background: #fff;\n    padding: 4px;\n    border-top-left-radius: 10px;\n    border-top-right-radius: 10px;\n    vertical-align: middle;\n    @apply bg-primary-200 cursor-not-allowed\n  }\n  \n  .toolbar button.toolbar-item {\n    border: 0;\n    display: flex;\n    background: none;\n    border-radius: 10px;\n    padding: 8px;\n    cursor: pointer;\n    vertical-align: middle;\n  }\n  \n  .toolbar button.toolbar-item:disabled {\n    cursor: not-allowed;\n  }\n  \n  .toolbar button.toolbar-item.spaced {\n    margin-right: 2px;\n  }\n  \n  .toolbar button.toolbar-item i.format {\n    background-size: contain;\n    height: 18px;\n    width: 18px;\n    margin-top: 2px;\n    vertical-align: -0.25em;\n    display: flex;\n    opacity: 0.6;\n  }\n  \n  .toolbar button.toolbar-item:disabled i.format {\n    opacity: 0.2;\n  }\n  \n  .toolbar button.toolbar-item.active {\n    background-color: rgba(223, 232, 250, 0.3);\n  }\n  \n  .toolbar button.toolbar-item.active i {\n    opacity: 1;\n  }\n  \n  .toolbar .toolbar-item:hover:not([disabled]) {\n    background-color: #eee;\n  }\n  \n  .toolbar .divider {\n    width: 1px;\n    background-color: #eee;\n    margin: 0 4px;\n  }\n  \n  .toolbar select.toolbar-item {\n    border: 0;\n    display: flex;\n    background: none;\n    border-radius: 10px;\n    padding: 8px;\n    vertical-align: middle;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    width: 70px;\n    font-size: 14px;\n    color: #777;\n    text-overflow: ellipsis;\n  }\n  \n  .toolbar select.code-language {\n    text-transform: capitalize;\n    width: 130px;\n  }\n  \n  .toolbar .toolbar-item .text {\n    display: flex;\n    line-height: 20px;\n    vertical-align: middle;\n    font-size: 14px;\n    color: #777;\n    text-overflow: ellipsis;\n    width: 70px;\n    overflow: hidden;\n    height: 20px;\n    text-align: left;\n  }\n  \n  .toolbar .toolbar-item .icon {\n    display: flex;\n    width: 20px;\n    height: 20px;\n    user-select: none;\n    margin-right: 8px;\n    line-height: 16px;\n    background-size: contain;\n  }\n  \n  .toolbar i.chevron-down {\n    margin-top: 3px;\n    width: 16px;\n    height: 16px;\n    display: flex;\n    user-select: none;\n  }\n  \n  .toolbar i.chevron-down.inside {\n    width: 16px;\n    height: 16px;\n    display: flex;\n    margin-left: -25px;\n    margin-top: 11px;\n    margin-right: 10px;\n    pointer-events: none;\n  }\n\n  .toolbar-disabled button.toolbar-item {\n    border: 0;\n    display: flex;\n    background: none;\n    border-radius: 10px;\n    padding: 8px;\n    cursor: pointer;\n    vertical-align: middle;\n  }\n  \n  .toolbar-disabled button.toolbar-item:disabled {\n    cursor: not-allowed;\n  }\n  \n  .toolbar-disabled button.toolbar-item.spaced {\n    margin-right: 2px;\n  }\n  \n  .toolbar-disabled button.toolbar-item i.format {\n    background-size: contain;\n    height: 18px;\n    width: 18px;\n    margin-top: 2px;\n    vertical-align: -0.25em;\n    display: flex;\n    opacity: 0.6;\n  }\n  \n  .toolbar-disabled button.toolbar-item:disabled i.format {\n    opacity: 0.2;\n  }\n  \n  .toolbar-disabled button.toolbar-item.active {\n    background-color: rgba(223, 232, 250, 0.3);\n  }\n  \n  .toolbar-disabled button.toolbar-item.active i {\n    opacity: 1;\n  }\n  \n  .toolbar-disabled .toolbar-item:hover:not([disabled]) {\n    background-color: #eee;\n  }\n  \n  .toolbar-disabled .divider {\n    width: 1px;\n    background-color: #eee;\n    margin: 0 4px;\n  }\n  \n  .toolbar-disabled select.toolbar-item {\n    border: 0;\n    display: flex;\n    background: none;\n    border-radius: 10px;\n    padding: 8px;\n    vertical-align: middle;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    width: 70px;\n    font-size: 14px;\n    color: #777;\n    text-overflow: ellipsis;\n  }\n  \n  .toolbar-disabled select.code-language {\n    text-transform: capitalize;\n    width: 130px;\n  }\n  \n  .toolbar-disabled .toolbar-item .text {\n    display: flex;\n    line-height: 20px;\n    vertical-align: middle;\n    font-size: 14px;\n    color: #777;\n    text-overflow: ellipsis;\n    width: 70px;\n    overflow: hidden;\n    height: 20px;\n    text-align: left;\n  }\n  \n  .toolbar-disabled .toolbar-item .icon {\n    display: flex;\n    width: 20px;\n    height: 20px;\n    user-select: none;\n    margin-right: 8px;\n    line-height: 16px;\n    background-size: contain;\n  }\n  \n  .toolbar-disabled i.chevron-down {\n    margin-top: 3px;\n    width: 16px;\n    height: 16px;\n    display: flex;\n    user-select: none;\n  }\n  \n  .toolbar-disabled i.chevron-down.inside {\n    width: 16px;\n    height: 16px;\n    display: flex;\n    margin-left: -25px;\n    margin-top: 11px;\n    margin-right: 10px;\n    pointer-events: none;\n  }\n  \n  i.chevron-down {\n    background-color: transparent;\n    background-size: contain;\n    display: inline-block;\n    height: 8px;\n    width: 8px;\n    background-image: url(images/icons/chevron-down.svg);\n  }\n  \n  #block-controls button:hover {\n    background-color: #efefef;\n  }\n  \n  #block-controls button:focus-visible {\n    border-color: blue;\n  }\n  \n  #block-controls span.block-type {\n    background-size: contain;\n    display: block;\n    width: 18px;\n    height: 18px;\n    margin: 2px;\n  }\n  \n  #block-controls span.block-type.paragraph {\n    background-image: url(images/icons/text-paragraph.svg);\n  }\n  \n  #block-controls span.block-type.h1 {\n    background-image: url(images/icons/type-h1.svg);\n  }\n  \n  #block-controls span.block-type.h2 {\n    background-image: url(images/icons/type-h2.svg);\n  }\n  \n  #block-controls span.block-type.quote {\n    background-image: url(images/icons/chat-square-quote.svg);\n  }\n  \n  #block-controls span.block-type.ul {\n    background-image: url(images/icons/list-ul.svg);\n  }\n  \n  #block-controls span.block-type.ol {\n    background-image: url(images/icons/list-ol.svg);\n  }\n  \n  #block-controls span.block-type.code {\n    background-image: url(images/icons/code.svg);\n  }\n  \n  .rtf-dropdown {\n    z-index: 5;\n    display: block;\n    position: absolute;\n    box-shadow: 0 12px 28px 0 rgba(0, 0, 0, 0.2), 0 2px 4px 0 rgba(0, 0, 0, 0.1),\n      inset 0 0 0 1px rgba(255, 255, 255, 0.5);\n    border-radius: 8px;\n    min-width: 100px;\n    min-height: 40px;\n    background-color: #fff;\n  }\n  \n  .rtf-dropdown .item {\n    margin: 0 8px 0 8px;\n    padding: 8px;\n    color: #050505;\n    cursor: pointer;\n    line-height: 16px;\n    font-size: 15px;\n    display: flex;\n    align-content: center;\n    flex-direction: row;\n    flex-shrink: 0;\n    justify-content: space-between;\n    background-color: #fff;\n    border-radius: 8px;\n    border: 0;\n    min-width: 268px;\n  }\n  \n  .rtf-dropdown .item .active {\n    display: flex;\n    width: 20px;\n    height: 20px;\n    background-size: contain;\n  }\n  \n  .rtf-dropdown .item:first-child {\n    margin-top: 8px;\n  }\n  \n  .rtf-dropdown .item:last-child {\n    margin-bottom: 8px;\n  }\n  \n  .rtf-dropdown .item:hover {\n    background-color: #eee;\n  }\n  \n  .rtf-dropdown .item .text {\n    display: flex;\n    line-height: 20px;\n    flex-grow: 1;\n    width: 200px;\n  }\n  \n  .rtf-dropdown .item .icon {\n    display: flex;\n    width: 20px;\n    height: 20px;\n    user-select: none;\n    margin-right: 12px;\n    line-height: 16px;\n    background-size: contain;\n  }\n  \n  .link-editor {\n    position: absolute;\n    z-index: 100;\n    top: -10000px;\n    left: -10000px;\n    margin-top: -6px;\n    max-width: 300px;\n    width: 100%;\n    opacity: 0;\n    background-color: #fff;\n    box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.3);\n    border-radius: 8px;\n    transition: opacity 0.5s;\n  }\n  \n  .link-editor .link-input {\n    display: block;\n    width: calc(100% - 24px);\n    box-sizing: border-box;\n    margin: 8px 12px;\n    padding: 8px 12px;\n    border-radius: 15px;\n    background-color: #eee;\n    font-size: 15px;\n    color: rgb(5, 5, 5);\n    border: 0;\n    outline: 0;\n    position: relative;\n    font-family: inherit;\n  }\n  \n  .link-editor div.link-edit {\n    background-image: url(images/icons/pencil-fill.svg);\n    background-size: 16px;\n    background-position: center;\n    background-repeat: no-repeat;\n    width: 35px;\n    vertical-align: -0.25em;\n    position: absolute;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    cursor: pointer;\n  }\n  \n  .link-editor .link-input a {\n    color: rgb(33, 111, 219);\n    text-decoration: none;\n    display: block;\n    white-space: nowrap;\n    overflow: hidden;\n    margin-right: 30px;\n    text-overflow: ellipsis;\n  }\n  \n  .link-editor .link-input a:hover {\n    text-decoration: underline;\n  }\n  \n  .link-editor .button {\n    width: 20px;\n    height: 20px;\n    display: inline-block;\n    padding: 6px;\n    border-radius: 8px;\n    cursor: pointer;\n    margin: 0 2px;\n  }\n  \n  .link-editor .button.hovered {\n    width: 20px;\n    height: 20px;\n    display: inline-block;\n    background-color: #eee;\n  }\n  \n  .link-editor .button i,\n  .actions i {\n    background-size: contain;\n    display: inline-block;\n    height: 20px;\n    width: 20px;\n    vertical-align: -0.25em;\n  }\n  \n  i.undo {\n    background-image: url(images/icons/arrow-counterclockwise.svg);\n  }\n  \n  i.redo {\n    background-image: url(images/icons/arrow-clockwise.svg);\n  }\n  \n  .icon.paragraph {\n    background-image: url(images/icons/text-paragraph.svg);\n  }\n  \n  .icon.large-heading,\n  .icon.h1 {\n    background-image: url(images/icons/type-h1.svg);\n  }\n  \n  .icon.small-heading,\n  .icon.h2 {\n    background-image: url(images/icons/type-h2.svg);\n  }\n  \n  .icon.bullet-list,\n  .icon.ul {\n    background-image: url(images/icons/list-ul.svg);\n  }\n  \n  .icon.numbered-list,\n  .icon.ol {\n    background-image: url(images/icons/list-ol.svg);\n  }\n  \n  .icon.quote {\n    background-image: url(images/icons/chat-square-quote.svg);\n  }\n  \n  .icon.code {\n    background-image: url(images/icons/code.svg);\n  }\n  \n  i.bold {\n    background-image: url(images/icons/type-bold.svg);\n  }\n  \n  i.italic {\n    background-image: url(images/icons/type-italic.svg);\n  }\n  \n  i.underline {\n    background-image: url(images/icons/type-underline.svg);\n  }\n  \n  i.strikethrough {\n    background-image: url(images/icons/type-strikethrough.svg);\n  }\n  \n  i.code {\n    background-image: url(images/icons/code.svg);\n  }\n  \n  i.link {\n    background-image: url(images/icons/link.svg);\n  }\n  \n  i.left-align {\n    background-image: url(images/icons/text-left.svg);\n  }\n  \n  i.center-align {\n    background-image: url(images/icons/text-center.svg);\n  }\n  \n  i.right-align {\n    background-image: url(images/icons/text-right.svg);\n  }\n  \n  i.justify-align {\n    background-image: url(images/icons/justify.svg);\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
